const styles = {
  container: (isCenterAligned: boolean) => ({
    display: 'inline-flex',
    flexWrap: 'wrap',
    gap: '0 4px',
    justifyContent: isCenterAligned ? 'center' : 'flex-start',
    width: '100%',
  }),
  link: {
    color: 'primary.main',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    overflowWrap: 'break-word',
    textDecoration: 'underline',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: 14,
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  ellipsis: {
    cursor: 'default',
    fontSize: 14,
  },
};

export default styles;
